import { api, invalidateItem, invalidateList, itemTags, listTags } from "../api";

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: "admins/signin",
        method: "POST",
        body: data,
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: "admins/logout",
        method: "POST",
      }),
    }),
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: "admins/forgot-password",
        method: "POST",
        body: data,
      }),
    }),
    resetPassword: builder.mutation({
      query: (data) => ({
        url: "admins/reset-password",
        method: "PATCH",
        body: data,
      }),
    }),
    updatePassword: builder.mutation({
      query: ({ id, data }) => ({
        url: `admins/update-password/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),

    // Admin management
    getAdmins: builder.query({
      query: (params) => ({
        url: "admins",
        method: "GET",
        params,
      }),
      providesTags: listTags("Admin"),
    }),
    getAdmin: builder.query({
      query: (id) => ({
        url: `admins/${id}`,
        method: "GET",
      }),
      providesTags: itemTags("Admin"),
    }),
    createAdmin: builder.mutation({
      query: (data) => ({
        url: "admins/signup",
        method: "POST",
        body: data,
      }),
      invalidatesTags: invalidateList("Admin"),
    }),
    updateAdmin: builder.mutation({
      query: ({ id, data }) => ({
        url: `admins/update/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: invalidateItem("Admin"),
    }),
    assignAdminRole: builder.mutation({
      query: ({ id, data }) => ({
        url: `admins/assign-role/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: invalidateItem("Admin"),
    }),
    deleteAdmin: builder.mutation({
      query: (id) => ({
        url: `admins/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: invalidateItem("Admin"),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useUpdatePasswordMutation,
  useGetAdminsQuery,
  useLazyGetAdminsQuery,
  useGetAdminQuery,
  useLazyGetAdminQuery,
  useCreateAdminMutation,
  useUpdateAdminMutation,
  useAssignAdminRoleMutation,
  useDeleteAdminMutation,
} = authApi;
